export const PATHOLOGICAL_PREEXISTING_MATERNAL_CONDITIONS = {
  id: 'pathological_preexisting_maternal_conditions',
  label: 'Gravidanza patologica per condizioni materne pregresse',
};
export const PATHOLOGICAL_MATERNAL_CONDITIONS_ONSET_DURING_PREGNANCY = {
  id: 'pathological_maternal_conditions_onset_during_pregnancy',
  label: 'Gravidanza patologica per condizioni materne insorte in gravidanza',
};
export const PATHOLOGICAL_FETAL_CONDITIONS = {
  id: 'pathological_fetal_conditions',
  label: 'Gravidanza patologica per condizioni fetali',
};
